import { createAction, props } from '@ngrx/store';
import { UiDefinition } from '../models/ui-definition.models';
import { UiAction } from '../models/ui-action.models';
import { UiComponent } from '../models/ui-component.models';
import { Presentation } from '../models/presentation.models';

export const getUiDefinitionFromUrl = createAction(
    '[Dynamic] Get UiDefinition from URL',
    props<{
        url: string,
        currentPersonId: string,
        currentVereinId: string,
        currentAnlassId: string
    }>()
);

export const getUiDefinitionFromName = createAction(
    '[Dynamic] Get UiDefinition from name',
    props<{
        name: string,
        currentPersonId: string,
        currentVereinId: string,
        currentAnlassId: string
    }>()
);

export const getUiDefinitionSuccess = createAction(
    '[Dynamic] Get UiDefinition success',
    props<{ info: string, uiDefinition: UiDefinition }>()
);

export const getUiDefinitionFailed = createAction(
    '[Dynamic] Get UiDefinition failed',
    props<{ info: string }>()
);

export const addActionToStore = createAction(
    '[Dynamic] add action to store',
    props<{ uiAction: UiAction }>()
);

export const executeAction = createAction(
    '[Dynamic] execute action',
    props<{ actionName: string, storeDataChildNames: string[], actionPath: String }>()
);

export const executeActionSuccess = createAction(
    '[Dynamic] execute action success',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const executeActionFailed = createAction(
    '[Dynamic] execute action failed',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const initLocalStore = createAction(
    '[Dynamic] init local store',
    props<{ uiComponents: UiComponent[], storeDataChildNames: string[] }>()
);

export const initChildStore = createAction(
    '[Dynamic] init child store',
    props<{ uiComponents: UiComponent[], storeDataChildNames: string[], name: string }>()
);

export const removeActionFromStore = createAction(
    '[Dynamic] remove action from store',
    props<{ storeDataChildNames: string[], name: string }>()
);

export const executeStoredProcedure = createAction(
    '[Dynamic] execute Stored Procedure',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const generatePDF = createAction(
    '[Dynamic] generate PDF',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const sendMail = createAction(
    '[Dynamic] send Mail',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const exportCsv = createAction(
    '[Dynamic] export Csv',
    props<{ uiAction: UiAction, storeDataChildNames: string[], actionPath: String }>()
);

export const removeDataInStore = createAction(
    '[Dynamic] remove data in store',
    props<{ storeName: string, storeDataName: string, storeDataPath: string, storeDataChildNames: string[], actionName: string }>()
);

export const saveDataInArrayWithIdInStore = createAction(
    '[Dynamic] save data in array with id in store',
    props<{ storeName: string, storeDataName: string, storeDataPath: string, idKey: string, idKeyValue: any, changeKey: string, changeValue: any, storeDataChildNames: string[], actionName: string }>()
);

export const getPresentation = createAction(
    '[Dynamic] Get presentation',
    props<{
        id: string
    }>()
);

export const getPresentationSuccess = createAction(
    '[Dynamic] Get presentation success',
    props<{
        presentation: Presentation
    }>()
);

export const getPresentationFailed = createAction(
    '[Dynamic] Get presentation failed',
    props<{
        errorMsg: string
    }>()
);

export const saveDataInLocalStore = createAction(
    '[Dynamic] save data in local store',
    props<{ storeDataName: string, storeDataPath: string, storeDataChildNames: string[], newValue: string, actionName: string }>()
);

export const saveDataInSessionStore = createAction(
    '[Dynamic] save data in session store',
    props<{ storeDataName: string, storeDataPath: string, newValue: string, actionName: string }>()
);

